<template>
  <v-row no-gutters>
    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snackState"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>
    <v-col cols="12">
      <v-data-table :headers="headers" :items="items" :search="search">
        <template v-slot:top>
          <v-toolbar elevation="0">
            <v-toolbar-title>Operadores Grua</v-toolbar-title>
            <v-divider inset vertical class="mx-3"></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              label="Buscar"
              outlined
              dense
              hide-details
            ></v-text-field>
            <v-divider vertical class="mx-3"></v-divider>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="nueva()">Nuevo</v-btn>
          </v-toolbar>
        </template>

        <template v-slot:[`item.editar`]="{ item }">
          <v-btn icon @click="editarItem(item)">
            <v-icon>tab</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-col>

    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-flex class="py-2">
            <v-text-field
              v-model="nombre"
              label="Nombre"
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex class="py-2">
            <v-autocomplete
              v-model="usuarioId"
              :items="usuarios"
              item-value="usuarioId"
              full-width
              item-text="nombre"
              label="Seleccionar Usuario"
              clearable
              dense
              filled
            >
              <template v-slot:item="data">
                <div>
                  <p class="ma-0 font-weight-medium">
                    {{ data.item.nombre }}
                  </p>
                  <p class="ma-0 caption">{{ data.item.username }}</p>
                </div>
              </template>
            </v-autocomplete>
          </v-flex>
        </v-card-text>
        <v-card-actions class="px-6">
          <v-btn color="primary" v-if="flag == 1" @click="crear()"
            >Guardar</v-btn
          >
          <v-btn color="primary" v-if="flag == 2" @click="actualizar()"
            >Actualizar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn text @click="cerrarDialog()">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    search: "",
    snackState: false,
    snackText: "",
    snackColor: "primary",
    snackTime: 3500,
    headers: [
      { text: "Nombre", value: "nombre" },
      { text: "Usuario", value: "usuario" },
      { text: "Editar", value: "editar" },
    ],
    items: [],
    dialog: false,
    usuarios: [],
    usuarioId: null,
    id_operador_grua: 0,
    nombre: "",
    flag: 1,
  }),
  created() {
    this.listar();
  },
  methods: {
    listar() {
      axios.get("api/OperadoresGruas/Listar").then((response) => {
        //console.log(response.data);
        this.items = response.data;
      });

      axios
        .get("api/Usuarios/ByRol")
        .then((res) => (this.usuarios = res.data))
        .catch((err) => console.error(err));
    },
    nueva() {
      this.flag = 1;
      this.dialog = true;
    },
    crear() {
      axios
        .post("api/OperadoresGruas/Crear", {
          nombre: this.nombre,
          usuarioId: this.usuarioId,
        })
        .then(() => {
          this.listar();
          this.cerrarDialog();
        });
    },
    actualizar() {
      axios
        .put("api/OperadoresGruas/Actualizar", {
          id_operador_grua: this.id_operador_grua,
          nombre: this.nombre,
          usuarioId: this.usuarioId,
        })
        .then(() => {
          this.cerrarDialog();
          this.listar();
        })
        .catch((err) => {
          if (err.response.status == 400) {
            this.snackState = true;
            this.snackColor = "red";
            this.snackText =
              "El Usuario ya está asignado a otro Operador de Grúa.";
            this.snackTime = 4000;
          }
          console.error(err);
        });
    },
    editarItem(item) {
      //console.log(item);
      this.flag = 2;

      this.id_operador_grua = item.id_operador_grua;
      this.nombre = item.nombre;
      this.usuarioId = item.usuarioId;

      this.dialog = true;
    },
    cerrarDialog() {
      this.dialog = false;

      this.nombre = "";
      this.usuarioId = null;
    },
  },
};
</script>